window.SwymCallbacks = window.SwymCallbacks || [];

window.SwymCallbacks.push((swat) => {
  if (!swat) return;

  const refresh = () => swat.initializeActionButtons('body');

  const updateCart = () => {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        data: { source: 'wishlist' }
      }
    }));
  };

  refresh();

  swat.evtLayer?.addEventListener(swat.JSEvents.UIAddedToCart, updateCart);
  swat.evtLayer?.addEventListener(swat.JSEvents.UIAddedAllToCart, updateCart);

  let t;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(refresh, 100);
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});